import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import BookCard from './BookCard'
import BookDetailModal from './BookDetailModal'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiBookOpen } = FiIcons

const BookGrid = ({ books, loading, onCheckout, onReturn, checkoutLoading, onLoginRedirect }) => {
  const [selectedBook, setSelectedBook] = useState(null)

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-white rounded-[2rem] border-2 border-white-400 overflow-hidden h-full">
            <div className="aspect-[3/4] bg-white-500 animate-pulse" />
            <div className="p-5 space-y-3">
              <div className="h-4 bg-white-500 animate-pulse rounded-lg w-3/4" />
              <div className="h-3 bg-white-500 animate-pulse rounded-lg w-1/2" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (books.length === 0) {
    return (
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center py-20">
        <div className="bg-white-500 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-6 border-2 border-white-400">
          <SafeIcon icon={FiBookOpen} className="w-10 h-10 text-white-400" />
        </div>
        <h3 className="text-lg font-black text-space_indigo uppercase tracking-tight mb-2">No volumes found</h3>
        <p className="text-white-300 font-bold text-xs uppercase tracking-widest">
          Try adjusting your search or refined filters.
        </p>
      </motion.div>
    )
  }

  return (
    <>
      <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {books.map((book, index) => (
          <motion.div
            key={book.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <BookCard 
              book={book} 
              onClick={setSelectedBook}
              isLoading={checkoutLoading === book.id} 
            />
          </motion.div>
        ))}
      </motion.div>

      <BookDetailModal 
        book={selectedBook}
        isOpen={!!selectedBook}
        onClose={() => setSelectedBook(null)}
        onCheckout={onCheckout}
        onReturn={onReturn}
        isLoading={checkoutLoading === selectedBook?.id}
        onLoginRedirect={onLoginRedirect}
      />
    </>
  )
}

export default BookGrid